import React from 'react';
import PropTypes from 'prop-types';
import { IntlMessages } from '@/components';
import appColors from '../../const/colors';

const TotalLabel = ({ total = 0 }) => {
  return (
    <span className="hp-badge-text hp-font-weight-600 hp-mb-0 hp-text-color-dark-30">
      <span style={{ color: appColors.darkGray }}>
        <IntlMessages id="ui-general-total" />
        {': '}
      </span>
      <span>{total}</span>
    </span>
  );
};

TotalLabel.propTypes = {
  total: PropTypes.number,
};

export default TotalLabel;
